import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  GROUP_TYPES,
  GROUP_VISUAL_STATE,
} from "features/planner/planner.constants";

import {
  getViewGroupFromState,
  getSearchTermFromState,
} from "features/planner/planner.selectors";

import Group from "features/planner/components/Group/Group";
import { getGroupCardsCompetencyStatus } from "features/planner/planner.actions";

class ViewGroupContainer extends PureComponent {
  componentDidUpdate(prevProps) {
    const { viewGroup } = prevProps;

    const prevGroupVisualState = viewGroup.get("groupVisualState");

    return this.maybeGetGroupCardsCompetencyStatus(prevGroupVisualState);
  }

  maybeGetGroupCardsCompetencyStatus = prevGroupVisualState => {
    const { viewGroup, dispatchGetGroupCardsCompetencyStatus } = this.props;

    const viewGroupType = viewGroup.get("type");
    const updatedGroupVisualState = viewGroup.get("groupVisualState");

    if (
      viewGroupType === GROUP_TYPES.LOCATION_GROUP &&
      prevGroupVisualState === GROUP_VISUAL_STATE.MINIMIZED &&
      updatedGroupVisualState === GROUP_VISUAL_STATE.NORMAL
    ) {
      dispatchGetGroupCardsCompetencyStatus(viewGroup.get("groupId"));
    }
  };

  render() {
    const {
      type,
      viewId,
      viewGroup,
      viewColumn,
      searchTerm,
      isEditMode,
      viewGroupId,
      viewColumnOrder,
    } = this.props;

    const groupVisualState = viewGroup.get("groupVisualState");

    const expanded = isEditMode
      ? false // always minimize when editing view
      : searchTerm
      ? true // always expand when searchTerm is defined
      : groupVisualState === GROUP_VISUAL_STATE.NORMAL; // fallback to the visual state of the group

    return (
      <Group
        type={type}
        viewId={viewId}
        expanded={expanded}
        viewColumn={viewColumn}
        isEditMode={isEditMode}
        viewGroupId={viewGroupId}
        viewColumnOrder={viewColumnOrder}
        groupId={viewGroup.get("groupId")}
      />
    );
  }
}

export default compose(
  connect(
    (state, { viewGroupId }) => ({
      searchTerm: getSearchTermFromState(state),
      viewGroup: getViewGroupFromState(state, viewGroupId),
    }),
    {
      dispatchGetGroupCardsCompetencyStatus: getGroupCardsCompetencyStatus,
    },
  ),
)(ViewGroupContainer);
